import React from "react";
import MenuBar from "../Component/MenuBar";
import PageBanner from '../Component/PageBanner';
import Sidebar from '../Component/Sidebar';
import Footer from "../Component/Footer";


import { Carousel } from "react-bootstrap";

const WinterRetreat = () => {
    const baseCell = {
        border: "1px solid #000",
        padding: "4px 6px",
        fontSize: 12,
        textAlign: "center"
    };

    const headCell = {
        ...baseCell,
        fontWeight: 600,
        backgroundColor: "#f3f3f3"
    };

    const timeCell = {
        ...baseCell,
        fontWeight: 600,
        backgroundColor: "#f9f9f9",
        position: "sticky",
        left: 0,
        zIndex: 2
    };

    const yellow = {
        ...baseCell,
        backgroundColor: "#ffe98a",
        fontWeight: 600
    };

    const yellowVertical = {
        ...yellow,
        writingMode: "vertical-rl",
        textOrientation: "mixed"
    };

    return (
        <>
            <MenuBar />
            <Sidebar />

            {/* <!-- Page Banner Section --> */}
            <PageBanner title="Winter Retreat" />

            {/* <!--End Banner Section --> */}


            <div className="container">



                <div className="auto-container">

                    <div className="centered">
                        <hr />
                        <h3> Winter Retreat </h3>
                        <hr />
                        <a href="https://ykportal.yugalkunj.org" target="_blank" className="alert alert-primary">
                            <span className="btn-title"><span className="fa fa-2x fa fa-hand-o-right"></span>  Please click here for registration </span>
                        </a>
                        <hr />
                    </div>
                </div>

                <div className="row">

                    <div className="col-lg-12">
                        <div className="card card-margin">
                            <div className="card-header no-border">
                                <h5 className="card-title"> Winter Retreat </h5>

                            </div>
                            <div className="card-body pt-0">
                                <div className="widget-49">


                                    <figure className="image">
                                        <img src="https://yugalkunj.org/images/winter-family-retreat.png" alt="" />
                                        <a href="https://yugalkunj.org/images/winter-family-retreat.png" className="lightbox-image overlay" data-fancybox="gallery-two"></a>
                                    </figure>
                                    <br />
                                    <div className="widget-49-meeting-action">
                                        <a href="https://yugalkunj.org/images/winter-family-retreat.png" target="_blank" className="btn btn-sm btn-flash-border-primary">View Flyer</a>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>


                </div>



            </div>


            <div className="container mt-4">
                <div className="card shadow-sm">
                    <div className="card-header bg-primary text-white">
                        Full Schedule (Date &amp; Time Wise)
                    </div>

                    <div
                        className="card-body"
                        style={{ overflowX: "auto", maxHeight: "800px" }}
                    >
                        <table
                            style={{
                                borderCollapse: "collapse",
                                minWidth: 1400,
                                position: "relative"
                            }}
                        >
                            <thead>
                                <tr>
                                    <th style={{ ...headCell, position: "sticky", left: 0, zIndex: 3 }}>
                                        Time
                                    </th>
                                    {[
                                        "Sat. Dec. 20",
                                        "Sun. Dec. 21",
                                        "Mon. Dec. 22",
                                        "Tue. Dec. 23",
                                        "Wed. Dec. 24",
                                        "Thu. Dec. 25",
                                        "Fri. Dec. 26",
                                        "Sat. Dec. 27",
                                        "Sun. Dec. 28",
                                        "Mon. Dec. 29",
                                        "Tue. Dec. 30",
                                        "Wed. Dec. 31",
                                        "Thu. Jan. 1"
                                    ].map((d) => (
                                        <th key={d} style={headCell}>
                                            {d}
                                        </th>
                                    ))}
                                </tr>
                            </thead>

                            <tbody>
                                {/* 6 – 6:20 */}
                                <tr>
                                    <td style={timeCell}>6:00 – 6:20 am</td>
                                    {Array(13)
                                        .fill("Divyopadesh")
                                        .map((txt, i) => (
                                            <td key={i} style={baseCell}>
                                                {txt}
                                            </td>
                                        ))}
                                </tr>

                                {/* 6:20 – 6:40 */}
                                <tr>
                                    <td style={timeCell}>6:20 – 6:40 am</td>
                                    {Array(13)
                                        .fill("Daily Prayer & Aartis")
                                        .map((txt, i) => (
                                            <td key={i} style={baseCell}>
                                                {txt}
                                            </td>
                                        ))}
                                </tr>

                                {/* 6:40 – 7:40 */}
                                <tr>
                                    <td style={timeCell}>6:40 – 7:40 am</td>
                                    {Array(13)
                                        .fill("Sadhana")
                                        .map((txt, i) => (
                                            <td key={i} style={baseCell}>
                                                {txt}
                                            </td>
                                        ))}
                                </tr>

                                {/* 7:40 – 8:00 */}
                                <tr>
                                    <td style={timeCell}>7:40 – 8:00 am</td>
                                    {Array(13)
                                        .fill("Bhog & Aarti")
                                        .map((txt, i) => (
                                            <td key={i} style={baseCell}>
                                                {txt}
                                            </td>
                                        ))}
                                </tr>

                                {/* 8:00 – 8:30 */}
                                <tr>
                                    <td style={timeCell}>8:00 – 8:30 am</td>
                                    {Array(13)
                                        .fill("Stretches")
                                        .map((txt, i) => (
                                            <td key={i} style={baseCell}>
                                                {txt}
                                            </td>
                                        ))}
                                </tr>

                                {/* 8:30 – 9:30  (Breakfast merged across all days) */}
                                <tr>
                                    <td style={timeCell}>8:30 – 9:30 am</td>
                                    <td colSpan={13} style={yellow}>
                                        Breakfast &amp; Free Time
                                    </td>
                                </tr>

                                {/* 9:30 – 10:00 (with Seva Time vertical on Jan 1, rowSpan=3) */}
                                <tr>
                                    <td style={timeCell}>9:30 – 10:00 am</td>
                                    <td style={baseCell}>M. Ji Video</td>
                                    <td style={baseCell}>Prep for Satsang</td>
                                    <td style={baseCell}>M. Ji Video</td>
                                    <td style={baseCell}>M. Ji Video</td>
                                    <td style={baseCell}>M. Ji Video</td>
                                    <td style={baseCell}>M. Ji Video</td>
                                    <td style={baseCell}>M. Ji Video</td>
                                    <td style={baseCell}>M. Ji Video</td>
                                    <td style={baseCell}>Prep for Satsang</td>
                                    <td style={baseCell}>M. Ji Video</td>
                                    <td style={baseCell}>M. Ji Video</td>
                                    <td style={baseCell}>M. Ji Video</td>
                                    <td rowSpan={3} style={yellowVertical}>
                                        Seva Time
                                    </td>
                                </tr>

                                {/* 10:00 – 10:30 */}
                                <tr>
                                    <td style={timeCell}>10:00 – 10:30 am</td>
                                    <td style={baseCell}>Leela Video</td>
                                    <td style={baseCell}>Sunday Satsang</td>
                                    <td style={baseCell}>Leela Video</td>
                                    <td style={baseCell}>Leela Video</td>
                                    <td style={baseCell}>Leela Video</td>
                                    <td style={baseCell}>Leela Video</td>
                                    <td style={baseCell}>Leela Video</td>
                                    <td style={baseCell}>Leela Video</td>
                                    <td style={baseCell}>Sunday Satsang</td>
                                    <td style={baseCell}>Leela Video</td>
                                    <td style={baseCell}>Leela Video</td>
                                    <td style={baseCell}>Leela Video</td>
                                    {/* last column is covered by rowSpan above */}
                                </tr>

                                {/* 10:30 – 10:45 */}
                                <tr>
                                    <td style={timeCell}>10:30 – 10:45 am</td>
                                    <td style={baseCell}>Indoor Parikrama</td>
                                    <td style={baseCell}>Sunday Satsang</td>
                                    <td style={baseCell}>Indoor Parikrama</td>
                                    <td style={baseCell}>Indoor Parikrama</td>
                                    <td style={baseCell}>Indoor Parikrama</td>
                                    <td style={baseCell}>Indoor Parikrama</td>
                                    <td style={baseCell}>Indoor Parikrama</td>
                                    <td style={baseCell}>Indoor Parikrama</td>
                                    <td style={baseCell}>Sunday Satsang</td>
                                    <td style={baseCell}>Indoor Parikrama</td>
                                    <td style={baseCell}>Indoor Parikrama</td>
                                    <td style={baseCell}>Indoor Parikrama</td>
                                    {/* last column again part of rowSpan */}
                                </tr>
                                {/* 10:45 – 12:00 pm */}
                                <tr>
                                    <td style={timeCell}>10:45 am – 12:00 pm</td>
                                    <td style={baseCell}>Keertan</td>
                                    <td style={baseCell}>Sunday Satsang</td>
                                    <td style={baseCell}>Keertan</td>
                                    <td style={baseCell}>Keertan</td>
                                    <td style={baseCell}>Keertan followed by Guru Paduka Pujan</td>
                                    <td style={baseCell}>Indoor Parikrama</td>
                                    <td style={baseCell}>Keertan</td>
                                    <td style={baseCell}>Bhog</td>
                                    <td style={baseCell}>Sunday Satsang</td>
                                    <td style={baseCell}>Keertan</td>
                                    <td style={baseCell}>Keertan</td>
                                    <td style={baseCell}>Keertan</td>
                                    <td style={baseCell}>Seva Time (Front Desk, Kitchen, Cleaning, Chanting in the hall)</td>
                                </tr>

                                {/* 12:00 pm Bhog */}
                                <tr>
                                    <td style={timeCell}>12:00 pm</td>
                                    {Array(13)
                                        .fill("Bhog")
                                        .map((txt, i) => (
                                            <td key={i} style={baseCell}>
                                                {txt}
                                            </td>
                                        ))}
                                </tr>

                                {/* 12:15 – 1:00 pm Lunch (yellow across all) */}
                                <tr>
                                    <td style={timeCell}>12:15 – 1:00 pm</td>
                                    <td colSpan={13} style={yellow}>
                                        Lunch
                                    </td>
                                </tr>

                                {/* 1:00 – 2:00 pm */}
                                <tr>
                                    <td style={timeCell}>1:00 – 2:00 pm</td>
                                    <td style={baseCell}></td>
                                    <td style={baseCell}>Rest Time</td>
                                    <td style={baseCell}></td>
                                    <td style={baseCell}></td>
                                    <td style={baseCell}></td>
                                    <td rowSpan={7} style={yellow}>
                                        Outing
                                    </td>
                                    <td style={baseCell}></td>
                                    <td style={baseCell}>Rest Time</td>
                                    <td style={baseCell}></td>
                                    <td style={baseCell}></td>
                                    <td style={baseCell}></td>
                                    <td style={baseCell}>Rest</td>
                                </tr>

                                {/* 2:00 – 2:20 pm */}
                                <tr>
                                    <td style={timeCell}>2:00 – 2:20 pm</td>
                                    <td style={baseCell}>Parikrama</td>
                                    <td style={baseCell}>Parikrama</td>
                                    <td style={baseCell}>Parikrama</td>
                                    <td style={baseCell}>Parikrama</td>
                                    <td style={baseCell}>Parikrama</td>
                                    {/* Outing column already rowSpanned */}
                                    <td style={yellow}></td>
                                    <td style={baseCell}>Parikrama</td>
                                    <td style={baseCell}>Parikrama</td>
                                    <td style={baseCell}>Parikrama</td>
                                    <td style={baseCell}>Parikrama</td>
                                    <td style={baseCell}>Parikrama</td>
                                    <td rowSpan={2} style={yellowVertical}>
                                        Seva Time 2 – 4:30 pm (Front Desk, Kitchen, Cleaning)
                                    </td>
                                </tr>

                                {/* 2:20 – 2:35 pm */}
                                <tr>
                                    <td style={timeCell}>2:20 – 2:35 pm</td>
                                    <td style={baseCell}>Guided Meditation</td>
                                    <td style={baseCell}>Guided Meditation</td>
                                    <td style={baseCell}>Guided Meditation</td>
                                    <td style={baseCell}>Guided Meditation</td>
                                    <td style={baseCell}>Guided Meditation</td>
                                    {/* Outing col rowSpan */}
                                    <td style={yellow}></td>
                                    <td rowSpan={3} style={yellow}>
                                        Seeta‑Ram Vivah
                                    </td>
                                    <td style={baseCell}>Guided Meditation</td>
                                    <td style={baseCell}>Guided Meditation</td>
                                    <td style={baseCell}>Guided Meditation</td>
                                    <td style={baseCell}>Guided Meditation</td>
                                    {/* last col part of Seva Time vertical rowSpan above */}
                                </tr>

                                {/* 2:35 – 4:00 pm */}
                                <tr>
                                    <td style={timeCell}>2:35 – 4:00 pm</td>
                                    <td style={baseCell}>Games</td>
                                    <td style={baseCell}>Games</td>
                                    <td style={baseCell}>Games</td>
                                    <td style={baseCell}>Games</td>
                                    <td style={baseCell}>
                                        Picnic on Yugal Kunj grounds
                                    </td>
                                    {/* Outing col rowSpan */}
                                    <td style={yellow}></td>

                                    <td style={baseCell}>Games</td>
                                    <td style={baseCell}>Games</td>
                                    <td style={baseCell}>Games</td>
                                    <td style={baseCell}>Games</td>

                                </tr>
                                {/* 4:00 – 4:30 pm */}
                                <tr>
                                    <td style={timeCell}>4:00 – 4:30 pm</td>
                                    <td style={baseCell}>Snacks</td>
                                    <td style={baseCell}>Snacks</td>
                                    <td style={baseCell}>Snacks</td>
                                    <td style={baseCell}>Snacks</td>
                                    <td style={baseCell}>Snacks</td>
                                    <td style={baseCell}>Snacks</td>
                                    <td style={baseCell}>Snacks</td>
                                    <td style={baseCell}>Snacks</td>
                                    <td style={baseCell}>Snacks</td>
                                    <td style={baseCell}>Snacks</td>
                                    <td style={baseCell}>Snacks</td>
                                    <td style={baseCell}>Snacks</td>
                                    <td rowSpan={2} style={yellowVertical}>
                                        Evening Satsang 4:30 – 8 pm
                                        <br />
                                        Keertans and Bhajan: Bhog &amp; Aarti
                                    </td>
                                </tr>

                                {/* 4:30 – 4:45 pm */}
                                <tr>
                                    <td style={timeCell}>4:30 – 4:45 pm</td>
                                    <td style={baseCell}>Zoom with Didis</td>
                                    <td style={baseCell}>Zoom with Didis</td>
                                    <td style={baseCell}>Zoom with Didis</td>
                                    <td style={baseCell}>Zoom with Didis</td>
                                    <td style={baseCell}>Zoom with Didis</td>
                                    <td style={baseCell}>Zoom with Didis</td>
                                    <td style={baseCell}>Zoom with Didis</td>
                                    <td style={baseCell}>Zoom with Didis</td>
                                    <td style={baseCell}>Zoom with Didis</td>
                                    <td style={baseCell}>Zoom with Didis</td>
                                    <td style={baseCell}>Zoom with Didis</td>
                                    <td style={baseCell}>Zoom with Didis</td>
                                    {/* last col is Evening Satsang rowSpan */}
                                </tr>

                                {/* 4:45 – 5:15 pm */}
                                <tr>
                                    <td style={timeCell}>4:45 – 5:15 pm</td>
                                    <td style={baseCell}>Keertan</td>
                                    <td style={baseCell}>Keertan</td>
                                    <td style={baseCell}>Keertan</td>
                                    <td style={baseCell}>Keertan</td>
                                    <td style={baseCell}>Keertan</td>
                                    <td style={baseCell}>Keertan</td>
                                    <td style={baseCell}>Keertan</td>
                                    <td style={baseCell}>Keertan</td>
                                    <td style={baseCell}>Keertan</td>
                                    <td style={baseCell}>Keertan</td>
                                    <td style={baseCell}>Keertan</td>
                                    <td style={baseCell}>Keertan</td>
                                    <td style={baseCell}></td>
                                </tr>

                                {/* 5:15 – 6:15 pm */}
                                <tr>
                                    <td style={timeCell}>5:15 – 6:15 pm</td>
                                    {Array(11)
                                        .fill("Didi Ji's Lecture")
                                        .map((txt, i) => (
                                            <td key={i} style={baseCell}>
                                                {txt}
                                            </td>
                                        ))}
                                    <td style={baseCell}></td>
                                    <td style={baseCell}></td>
                                </tr>

                                {/* 6:15 – 6:40 pm */}
                                <tr>
                                    <td style={timeCell}>6:15 – 6:40 pm</td>
                                    {Array(11)
                                        .fill("Bhog & Aarti")
                                        .map((txt, i) => (
                                            <td key={i} style={baseCell}>
                                                {txt}
                                            </td>
                                        ))}
                                    <td style={baseCell}></td>
                                    <td style={baseCell}></td>
                                </tr>

                                {/* 6:40 – 7:45 pm  Dinner yellow across all days */}
                                <tr>
                                    <td style={timeCell}>6:40 – 7:45 pm</td>
                                    <td colSpan={13} style={yellow}>
                                        Dinner
                                    </td>
                                </tr>

                                {/* 7:45 – 8:00 pm */}
                                <tr>
                                    <td style={timeCell}>7:45 – 8:00 pm</td>
                                    <td style={baseCell}>Lighter Moments</td>
                                    <td style={baseCell}>Lighter Moments</td>
                                    <td style={baseCell}>Lighter Moments</td>
                                    <td style={baseCell}>Lighter Moments</td>
                                    <td style={baseCell}>Lighter Moments</td>
                                    <td rowSpan={2} style={yellow}>
                                        Meri Radhey Divas Cultural Program
                                    </td>
                                    <td style={baseCell}>Lighter Moments</td>
                                    <td style={baseCell}>Lighter Moments</td>
                                    <td style={baseCell}>Lighter Moments</td>
                                    <td style={baseCell}>Lighter Moments</td>
                                    <td style={baseCell}>Lighter Moments</td>
                                    <td style={baseCell}>Lighter Moments</td>
                                    <td style={yellow}>
                                        Prep for Extended Keertan
                                    </td>
                                </tr>

                                {/* 8:00 – 9:00 pm */}
                                <tr>
                                    <td style={timeCell}>8:00 – 9:00 pm</td>
                                    {Array(6)
                                        .fill("Keertan")
                                        .map((txt, i) => (
                                            <td key={i} style={baseCell}>
                                                {txt}
                                            </td>
                                        ))}
                                    {/* Meri Radhey Divas col rowSpan already used */}
                                    <td style={baseCell}>Keertan</td>
                                    <td style={baseCell}>Keertan</td>
                                    <td style={baseCell}>Keertan</td>
                                    <td style={baseCell}>Keertan</td>
                                    <td style={baseCell}>Keertan</td>
                                    <td rowSpan={3} style={yellowVertical}>
                                        Extended Keertan till Midnight
                                    </td>
                                </tr>

                                {/* 9:00 – 10:00 pm */}
                                <tr>
                                    <td style={timeCell}>9:00 – 10:00 pm</td>
                                    {Array(11)
                                        .fill("")
                                        .map((_, i) => (
                                            <td key={i} style={baseCell}></td>
                                        ))}
                                    <td style={baseCell}></td>
                                    {/* last col is Extended Keertan rowSpan */}
                                </tr>

                                {/* 10:00 – 11:00 pm */}
                                <tr>
                                    <td style={timeCell}>10:00 – 11:00 pm</td>
                                    {Array(11)
                                        .fill("")
                                        .map((_, i) => (
                                            <td key={i} style={baseCell}></td>
                                        ))}
                                    <td style={baseCell}></td>
                                    {/* last col Extended Keertan */}
                                </tr>

                                {/* 11:00 pm – 12:00 am */}
                                <tr>
                                    <td style={timeCell}>11:00 pm – 12:00 am</td>
                                    {Array(12)
                                        .fill("")
                                        .map((_, i) => (
                                            <td key={i} style={baseCell}></td>
                                        ))}
                                    <td style={baseCell}></td>
                                </tr>



                                {/* CONTINUE: build remaining rows EXACTLY like the sheet:
                    - 10:45–12:00 Keertan / Keertan + Pujan / etc.
                    - 12:00 Bhog across all days
                    - 12:15–1:00 Lunch yellow colSpan=13
                    - Outing yellow block (Fri) with rowSpan across time rows
                    - Seeta-Ram Vivah yellow block (Sat) rowSpan+colSpan
                    - Prep for Extended Keertan, Extended Keertan till Midnight, etc.
                 */}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default WinterRetreat;
